/**
 * Capacitor Initialization
 * Auto-generated — registers PWA elements and detects platform.
 *
 * Import this in main.tsx BEFORE ReactDOM.createRoot():
 *   import './capacitor-init';
 */
import { Capacitor } from '@capacitor/core';

// Register PWA elements (camera overlay, toast, etc.) for web platform
async function initCapacitor() {
  if (!Capacitor.isNativePlatform()) {
    try {
      const { defineCustomElements } = await import('@ionic/pwa-elements/loader');
      defineCustomElements(window);
    } catch {
      // @ionic/pwa-elements not installed — camera will use basic file input
      console.debug('PWA elements not available — using fallback UI');
    }
  }
}

initCapacitor();

// Export platform info for conditional rendering
export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'web' | 'ios' | 'android'
